module.exports = __webpack_public_path__ + "media/images/yahoo-3b03b73a0b6d0cff674f66710f0002b7.png";